<!-- centerbox -->
<template>
    <div class='card_wrapper' ref="center1">
        <div class="box">
            <div class="title box_f1">{{partyName}}</div>
            <Icon type="md-close-circle"  class="close" @click="close"/>
        </div>
        <scroll  :style="{'height':height}" v-show="!loading">
            
            <div class="subititle box_f1">简介</div>
            <div class="subcontent">{{partyData.remark || '暂无简介'}}</div>
            <div class="imgbox box">
                <div class="imgitem" v-for="item in partyData.picList" :key="item.picId">
                    <img :src="item.picPath" v-if="item.picPath"/>
                </div>
               
            </div>
            
            <div v-for="(value, key) in partyData.userMapList" :key="key">
                <div class="subititle">{{key}}</div>
                <div class="userlistbox box">
                    <div v-if="value.length==0" class="nodata">暂无数据</div>
                    <div  v-else v-for="item in value" :key="item.id" class="useritem box">
                        <img v-if="item.headPicUrl" :src="item.headPicUrl" />
                        <div v-else class="defaultPeople"></div>
                        <div class="box box_v box_around">
                            <div class="name">{{item.userName}}</div>
                            <div  class="protitle">{{item.proTitle}}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </scroll>
        <Spin fix v-if="loading">加载中...</Spin>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import scroll from './scroll'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {scroll},
    data() {
    //这里存放数据
        return {
            height:'100%',
            partyData:{},
            loading:true
        };
    },
    props:{
        partyId:{
            default:'',
            type:String
        },
        partyName:{
            default:'',
            type:String
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.xf_partyDetail(this.partyId)).then(res=>{
                this.partyData = res.rows[0]
                this.loading=false
            })
        },
        close(){
            this.$emit('close')
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
            this.height = this.$refs.center1.offsetHeight-68 + 'px'
            this.getData()
        })
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/center.png');
    background-size: 100% 100%;
    .title{
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        padding: 20px 0 0 20px;
    }
    .close{
        font-size: 18px;
        color:#FFADA5;
        padding:20px 20px 0 0;
        height:38px;
        cursor: pointer;
    }
    .subititle{
        margin:20px;
        padding-left:10px;
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        border-left:2px solid #fff
    }
    .subcontent{
        margin:0 20px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        text-indent: 2em
    }
    .imgbox{
        flex-wrap: wrap;
        margin-left:32px;
        .imgitem{
            width: 154px;
            height: 92px;
            margin:5px 5px 0px 0;
            img{
                width: 154px;
                height: 92px;
            }
        }
        
    }
    .userlistbox{
        flex-wrap: wrap;
        margin-left:30px;
        border-bottom:1px solid #B32A21;
        .useritem{
            width:40%;
            color:#fff;
            margin-bottom:20px;
            img{
                width: 52px;
                height: 52px;
                border-radius: 50%;
                margin-right:10px
            }
            .defaultPeople{
                width: 52px;
                height: 52px;
                border-radius: 50%;
                margin-right:10px;
                background-image: url('../../../assets/images/monitorctxf/defaultPeople.png');
                background-size: 100% 100%;
                background-repeat: no-repeat
            }
            .name{
                font-size: 16px;
                font-weight: bold;
                color: #FFFFFF;
            }
            .protitle{
                width: 100%;
                font-size: 14px;
                color: #FFD0D0;
                word-break: break-all;
            }
            
        }
        .nodata{
                font-size: 14px;
                color:#fff;
                margin-bottom: 20px;
                margin-left: -10px;
                text-indent: 2em;
            }
    }
}
.card_wrapper /deep/ .ivu-spin-fix{
    background-color: transparent !important;
}
.card_wrapper /deep/ .ivu-spin{
    color:#fff !important;
}
</style>